"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cols-form tab-card-validation-face-component"
  }, [_c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [!_vm.hasFaceContent ? _c("not-found") : _vm._e(), _vm._v(" "), _vm.hasFaceContent ? _c("card", {
    staticClass: "card-detail-image biometric-validation-card"
  }, [_c("div", {
    staticClass: "biometric-validation"
  }, [_c("div", {
    staticClass: "biometric-validation__hero"
  }, [_c("div", {
    staticClass: "biometric-validation__media"
  }, [_vm.validationFace ? _c("img", {
    staticClass: "img-raised",
    attrs: {
      src: _vm.validationFace,
      alt: "Imagem utilizada na validação facial"
    },
    on: {
      click: function click($event) {
        return _vm.openModal(_vm.validationFace);
      }
    }
  }) : _c("img", {
    staticClass: "img-raised",
    attrs: {
      src: require("@/assets/images/avatar-default.png"),
      alt: "Imagem de validação facial indisponível"
    }
  }), _vm._v(" "), _vm.validationFace ? _c("button", {
    staticClass: "button is-small biometric-validation__preview-button",
    on: {
      click: function click($event) {
        return _vm.openModal(_vm.validationFace);
      }
    }
  }, [_vm._v("\n                Ampliar imagem\n              ")]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "biometric-validation__summary"
  }, [_c("div", {
    staticClass: "biometric-validation__eyebrow"
  }, [_vm._v("\n                Resultado da Análise Facial\n              ")]), _vm._v(" "), _c("div", {
    staticClass: "biometric-validation__headline"
  }, [_c("div", [_c("h2", [_vm._v(_vm._s(_vm.summaryStatus.title))]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.summaryStatus.description))])]), _vm._v(" "), _c("span", {
    class: ["tag", "biometric-validation__status-chip", _vm.summaryStatus.tagClass]
  }, [_c("b-icon", {
    attrs: {
      icon: _vm.summaryStatus.icon,
      size: "is-small"
    }
  }), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.summaryStatus.tagLabel))])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "biometric-validation__meta"
  }, [_vm.validationDate ? _c("div", {
    staticClass: "biometric-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "calendar",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Data da validação")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm._f("dateComplete")(_vm.validationDate)))])])], 1) : _vm._e(), _vm._v(" "), _vm.statusFieldLabel ? _c("div", {
    staticClass: "biometric-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "clipboard-check",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Status do processamento")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.statusFieldLabel))])])], 1) : _vm._e(), _vm._v(" "), _vm.facematchScoreCard ? _c("div", {
    staticClass: "biometric-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: _vm.facematchScoreCard.icon,
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v(_vm._s(_vm.facematchScoreCard.label))]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.facematchScoreCard.text))])])], 1) : _vm._e()])])]), _vm._v(" "), _vm.biometricValidationItems.length ? _c("div", {
    staticClass: "biometric-validation__content"
  }, [_vm.biometricValidationItems.length ? _c("section", {
    staticClass: "biometric-validation__section"
  }, [_c("div", {
    staticClass: "biometric-validation__section-header"
  }, [_c("div", {
    staticClass: "biometric-validation__section-title"
  }, [_c("b-icon", {
    attrs: {
      icon: "account-check"
    }
  }), _vm._v(" "), _c("h3", [_vm._v("Validação Biométrica")])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "biometric-validation__grid"
  }, _vm._l(_vm.biometricValidationItems, function (item) {
    return _c("div", {
      key: item.key,
      class: ["biometric-validation__item-card", "is-".concat(item.tone)]
    }, [_c("div", {
      staticClass: "biometric-validation__item-head"
    }, [_c("div", {
      staticClass: "biometric-validation__item-icon"
    }, [_c("b-icon", {
      attrs: {
        icon: item.icon
      }
    })], 1), _vm._v(" "), _c("span", {
      class: ["tag", "biometric-validation__item-tag", "is-".concat(item.tone)]
    }, [_vm._v("\n                      " + _vm._s(item.tag) + "\n                    ")])]), _vm._v(" "), _c("h4", [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(item.text))]), _vm._v(" "), item.helper ? _c("p", [_vm._v(_vm._s(item.helper))]) : _vm._e(), _vm._v(" "), item.aliases ? _c("p", {
      staticClass: "biometric-validation__item-aliases"
    }, [_vm._v("\n                    (" + _vm._s(item.aliases) + ")\n                  ")]) : _vm._e()]);
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.faceHistoryAttempts.length ? _c("section", {
    staticClass: "biometric-validation__section biometric-validation__history"
  }, [_c("div", {
    staticClass: "biometric-validation__section-header"
  }, [_c("div", {
    staticClass: "biometric-validation__section-title"
  }, [_c("b-icon", {
    attrs: {
      icon: "history"
    }
  }), _vm._v(" "), _c("h3", [_vm._v("Histórico de tentativas")])], 1), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.faceHistoryDescription))])]), _vm._v(" "), _c("div", {
    staticClass: "biometric-validation__attempts"
  }, _vm._l(_vm.faceHistoryAttempts, function (attempt) {
    return _c("b-collapse", {
      key: attempt.key,
      staticClass: "biometric-attempt",
      attrs: {
        animation: "slide",
        open: false
      },
      scopedSlots: _vm._u([{
        key: "trigger",
        fn: function fn(props) {
          return [_c("div", {
            staticClass: "biometric-attempt__trigger",
            attrs: {
              role: "button",
              tabindex: "0",
              "aria-expanded": props.open
            },
            on: {
              keydown: [function ($event) {
                if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
                $event.preventDefault();
                return $event.currentTarget.click();
              }, function ($event) {
                if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
                $event.preventDefault();
                return $event.currentTarget.click();
              }]
            }
          }, [_c("div", {
            staticClass: "biometric-attempt__summary"
          }, [_c("span", {
            staticClass: "biometric-attempt__number"
          }, [_vm._v(_vm._s(attempt.label))]), _vm._v(" "), _c("div", [_c("h4", [_vm._v(_vm._s(attempt.resultTitle))]), _vm._v(" "), attempt.date ? _c("p", [_vm._v("\n                          " + _vm._s(_vm._f("dateComplete")(attempt.date)) + "\n                        ")]) : _c("p", [_vm._v("\n                          Data e hora não informadas\n                        ")])])]), _vm._v(" "), _c("div", {
            staticClass: "biometric-attempt__tags"
          }, [attempt.isCurrentResult ? _c("span", {
            staticClass: "tag biometric-attempt__tag biometric-attempt__tag--current"
          }, [_vm._v("\n                        Resultado atual\n                      ")]) : _vm._e(), _vm._v(" "), _c("span", {
            class: ["tag", "biometric-attempt__tag", "is-".concat(attempt.resultTone)]
          }, [_vm._v("\n                        " + _vm._s(attempt.resultLabel) + "\n                      ")]), _vm._v(" "), attempt.scoreLabel ? _c("span", {
            staticClass: "tag biometric-attempt__tag biometric-attempt__tag--score"
          }, [_vm._v("\n                        " + _vm._s(attempt.scoreLabel) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c("b-icon", {
            attrs: {
              icon: props.open ? "menu-up" : "menu-down"
            }
          })], 1)])];
        }
      }], null, true)
    }, [_vm._v(" "), _c("div", {
      staticClass: "biometric-attempt__content"
    }, [_c("figure", {
      staticClass: "biometric-attempt__media"
    }, [_c("div", {
      staticClass: "biometric-attempt__media-header"
    }, [_c("b-icon", {
      attrs: {
        icon: "face-recognition",
        size: "is-small"
      }
    }), _vm._v(" "), _c("span", [_vm._v("Face utilizada")])], 1), _vm._v(" "), _vm.isAttemptImageAvailable(attempt) ? [_c("button", {
      staticClass: "biometric-attempt__image-button",
      attrs: {
        type: "button",
        "aria-label": "Ampliar imagem da ".concat(attempt.label.toLowerCase())
      },
      on: {
        click: function click($event) {
          return _vm.openModal(attempt.image);
        }
      }
    }, [_c("img", {
      attrs: {
        src: attempt.image,
        alt: "Face utilizada na ".concat(attempt.label.toLowerCase())
      },
      on: {
        error: function error($event) {
          return _vm.handleAttemptImageError(attempt.key);
        }
      }
    }), _vm._v(" "), _c("span", {
      staticClass: "biometric-attempt__image-overlay"
    }, [_c("b-icon", {
      attrs: {
        icon: "magnify-plus-outline",
        size: "is-small"
      }
    }), _vm._v("\n                          Ampliar\n                        ")], 1)]), _vm._v(" "), _c("figcaption", [_vm._v("Imagem capturada nesta tentativa")])] : _c("div", {
      staticClass: "biometric-attempt__image-empty",
      attrs: {
        role: "img",
        "aria-label": "Imagem da ".concat(attempt.label.toLowerCase(), " indispon\xEDvel")
      }
    }, [_c("b-icon", {
      attrs: {
        icon: "image-off-outline"
      }
    }), _vm._v(" "), _c("span", [_vm._v("Imagem não disponível")])], 1)], 2), _vm._v(" "), _c("div", {
      staticClass: "biometric-attempt__details"
    }, [_c("div", {
      staticClass: "biometric-attempt__meta-grid"
    }, [attempt.statusLabel ? _c("div", {
      staticClass: "biometric-attempt__meta-item"
    }, [_c("span", [_vm._v("Status")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(attempt.statusLabel))])]) : _vm._e(), _vm._v(" "), attempt.scoreLabel ? _c("div", {
      staticClass: "biometric-attempt__meta-item"
    }, [_c("span", [_vm._v("Score FaceMatch")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(attempt.scoreLabel))])]) : _vm._e(), _vm._v(" "), attempt.spoofLabel ? _c("div", {
      staticClass: "biometric-attempt__meta-item"
    }, [_c("span", [_vm._v("Anti-spoofing")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(attempt.spoofLabel))])]) : _vm._e()]), _vm._v(" "), attempt.failureReason || attempt.errorMessage ? _c("div", {
      staticClass: "biometric-attempt__alert"
    }, [_c("b-icon", {
      attrs: {
        icon: "alert-circle"
      }
    }), _vm._v(" "), _c("div", [attempt.failureReason ? _c("strong", [_vm._v(_vm._s(attempt.failureReason))]) : _vm._e(), _vm._v(" "), attempt.errorMessage ? _c("p", [_vm._v(_vm._s(attempt.errorMessage))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), attempt.diagnostics.length ? _c("div", {
      staticClass: "biometric-attempt__diagnostics"
    }, _vm._l(attempt.diagnostics, function (diagnostic) {
      return _c("div", {
        key: "".concat(attempt.key, "-").concat(diagnostic.key),
        class: ["biometric-attempt__diagnostic", "is-".concat(diagnostic.tone)]
      }, [_c("b-icon", {
        attrs: {
          icon: diagnostic.icon,
          size: "is-small"
        }
      }), _vm._v(" "), _c("div", [_c("span", [_vm._v(_vm._s(diagnostic.label))]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(diagnostic.text))])])], 1);
    }), 0) : _vm._e(), _vm._v(" "), attempt.identifiers.length ? _c("div", {
      staticClass: "biometric-attempt__identifiers"
    }, _vm._l(attempt.identifiers, function (identifier) {
      return _c("div", {
        key: "".concat(attempt.key, "-").concat(identifier.label)
      }, [_c("span", [_vm._v(_vm._s(identifier.label))]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(identifier.value))])]);
    }), 0) : _vm._e()])])]);
  }), 1)]) : _vm._e()])]) : _vm._e()], 1)]), _vm._v(" "), _c("b-modal", {
    model: {
      value: _vm.isImageModalActive,
      callback: function callback($$v) {
        _vm.isImageModalActive = $$v;
      },
      expression: "isImageModalActive"
    }
  }, [_c("b-image", {
    attrs: {
      src: _vm.imgSelected,
      "webp-fallback": ".jpg"
    }
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;